export const DSS_DASHBOARD_URL = "https://app.digitalseaservice.com/dashboard";
